module.exports = __webpack_public_path__ + "img/josh-hild-1407748-unsplash.6f4af719.jpg";